import gql from 'graphql-tag';

const PRODUCTS_QUERY = gql`
  query GetItems($params: ItemFilterInput, $page: Int, $pageSize: Int) {
    getItems(params: $params, page: $page, pageSize: $pageSize) {
      page
      pages
      items {
        hash_id
        name
        description
        slug
        image_urls
        brand
        brands_id
        short_id
        short_id_brand
      }
    }
  }
`;

export default PRODUCTS_QUERY;



// WEBPACK FOOTER //
// ./src/graphql/queries/products.query.js